export default __webpack_public_path__ + "static/media/bg-Join.dcf171ba.jpg";